// extracted by mini-css-extract-plugin
module.exports = {"row":"image-text-row-module--row--2-GFa","rev":"image-text-row-module--rev--2Rlt7"};